export default /* html */ `
<ui-page>
  <ui-page-body>
    <ui-page-content>
      <ui-heading class="heading" type="h1">Projects</ui-heading>

      <div class="project">
        <ui-card>
          <ui-card-content>
            <div class="project__container">
              <span class="project__title">ARM 32 emulator</span>
              <div class="project__content">
                <span>An ARM 32 emulator in JavaScript.</span>
              </div>
              <div class="project__footer">
                <ui-button target="_blank" href="https://vm-js-27b6a.web.app/">View</ui-button>
              </div>
            </div>
          </ui-card-content>
        </ui-card>
        <ui-card>
          <ui-card-image class="project__image" src="/arm32emulator.png"></ui-card-image>
        </ui-card>
      </div>

      <div class="project">
        <ui-card>
          <ui-card-content>
            <div class="project__container">
              <span class="project__title">ScaffoldJS</span>
              <div class="project__content">
                <span>A JavaScript frontend framework.</span>
              </div>
              <div class="project__footer">
                <ui-button target="_blank" href="https://scaffoldjs-36893.web.app/">View</ui-button>
              </div>
            </div>
          </ui-card-content>
        </ui-card>
        <ui-card>
          <ui-card-image class="project__image" src="/scaffoldjs.png"></ui-card-image>
        </ui-card>
      </div>

      <div class="project">
        <ui-card>
          <ui-card-content>
            <div class="project__container">
              <span class="project__title">Material UI React</span>
              <div class="project__content">
                <span>React UI library based on Material Design 3</span>
              </div>
              <div class="project__footer">
                <ui-button target="_blank" href="https://material-ui-react-bcdf4.web.app/">View</ui-button>
              </div>
            </div>
          </ui-card-content>
        </ui-card>
        <ui-card>
          <ui-card-image class="project__image" src="/material-ui-react.png"></ui-card-image>
        </ui-card>
      </div>

    </ui-page-content>
  </ui-page-body>
</ui-page>
`
